import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { NavigationContextProvider } from './Navigation.context';
import Container from './components/Container';
import Item from './components/Item';
import Link from './components/Link';
import Links from './components/Links';
import Logo from './components/Logo';
import Menu from './components/Menu';
import Toggle from './components/Toggle';
import { ChildrenPropType, StylePropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import useScroll from '../../../foundation/hooks/use-scroll/use-scroll';
import './Navigation.css';
var defaultProps = {
  mobile: null,
  tablet: null,
  sticky: false,
  fullScreen: false,
  id: null,
  className: '',
  style: {}
};
export default function Navigation(_ref) {
  var desktop = _ref.desktop,
    mobile = _ref.mobile,
    tablet = _ref.tablet,
    fullScreen = _ref.fullScreen,
    sticky = _ref.sticky,
    id = _ref.id,
    className = _ref.className,
    style = _ref.style;
  var _useScroll = useScroll(),
    enableBodyScroll = _useScroll.enableBodyScroll,
    disableBodyScroll = _useScroll.disableBodyScroll;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggled = _useState2[0],
    setToggled = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    openedAccordionPopups = _useState4[0],
    setOpenedAccordionPopups = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    openedDropdownMenus = _useState6[0],
    setOpenedDropdownMenus = _useState6[1];
  useEffect(function () {
    if (fullScreen) {
      if (toggled) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    }
  }, [fullScreen, toggled]);
  var desktopContent = desktop;
  var mobileContent = mobile || tablet || desktop;
  var tabletContent = tablet || mobile || desktop;
  var allClassNames = classNames(_defineProperty({
    navigation: true,
    sticky: sticky,
    toggled: toggled,
    'full-screen': fullScreen
  }, className, true));
  var contextValue = {
    toggled: toggled,
    setToggled: setToggled,
    openedDropdownMenus: openedDropdownMenus,
    setOpenedDropdownMenus: setOpenedDropdownMenus,
    openedAccordionPopups: openedAccordionPopups,
    setOpenedAccordionPopups: setOpenedAccordionPopups
  };
  return /*#__PURE__*/React.createElement("div", {
    className: allClassNames,
    id: id,
    style: style,
    role: "navigation"
  }, /*#__PURE__*/React.createElement(NavigationContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop"
  }, desktopContent), /*#__PURE__*/React.createElement("div", {
    className: "mobile"
  }, mobileContent), /*#__PURE__*/React.createElement("div", {
    className: "tablet"
  }, tabletContent)));
}
Navigation.defaultProps = defaultProps;
Navigation.Container = Container;
Navigation.Menu = Menu;
Navigation.Item = Item;
Navigation.Logo = Logo;
Navigation.Link = Link;
Navigation.Links = Links;
Navigation.Toggle = Toggle;